import quickFetch from 'quick-fetch';
import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
const TEMPLATES_EARLY_REQUEST_NAME = 'reportTemplates';
const REPORT_TEMPLATES_BASE_URL = 'reporting-discovery/v1/report-template';
export const getReportTemplates = (query = {}) => {
  return http.get(REPORT_TEMPLATES_BASE_URL, {
    query
  }).then(fromJS);
};
export const getRecentlyUpdatedTemplates = () => {
  const query = {
    sort: 'UPDATED_AT',
    sortDirection: 'DESCENDING',
    limit: 10,
    offset: 0,
    hydrate: [],
    internalTags: ['marketing-analytics-suite', 'sales-analytics-suite', 'service-analytics-suite', 'commerce-analytics-suite'],
    statuses: ['ACTIVE']
  };
  return http.get(`${REPORT_TEMPLATES_BASE_URL}/paged`, {
    query
  }).then(fromJS);
};
export const getReportTemplateByKey = templateKey => {
  return http.get(`${REPORT_TEMPLATES_BASE_URL}/template-key/${templateKey}`).then(fromJS);
};
export const getReportCollectionTemplates = () => {
  const earlyRequest = quickFetch.getRequestStateByName(TEMPLATES_EARLY_REQUEST_NAME);
  const query = {
    internalTags: ['marketing-analytics-suite', 'sales-analytics-suite', 'service-analytics-suite', 'commerce-analytics-suite'],
    hydrate: []
  };
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(request => {
        resolve(fromJS(request));
        quickFetch.removeEarlyRequest(TEMPLATES_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError((xhr, errorMsg) => {
        if (xhr.status === 401) {
          reject(errorMsg);
        } else {
          getReportTemplates(query).then(resolve).catch(reject);
        }
        quickFetch.removeEarlyRequest(TEMPLATES_EARLY_REQUEST_NAME);
      });
    });
  }
  return getReportTemplates(query);
};